export type CreateSurveyOptionType = 'advance' | 'front' | 'location';

export interface CreateSurveyOption {
  key: number;
  value: string;
  type: CreateSurveyOptionType;
}

export const CREATE_SURVEY_POSITION_OPTIONS: CreateSurveyOption[] = [
  { key: 0, value: 'Advance Targeting search view', type: 'advance' },
  { key: 1, value: 'Front View', type: 'front' },
  { key: 2, value: 'Location', type: 'location' },
];

export const CREATE_SURVEY_COMPONENT_OPTIONS: CreateSurveyOption[] = [
  { key: 0, value: 'Advance View', type: 'advance' },
  { key: 1, value: 'Dropdown', type: 'front' },
  { key: 2, value: 'Upload', type: 'location' },
  { key: 3, value: 'Search', type: 'location' },
  { key: 5, value: 'Grid', type: 'location' },
];

export const DEFAULT_CREATE_SURVEY_POSITION_ID = 0;
export const DEFAULT_CREATE_SURVEY_COMPONENT_ID = 0;

export const PRIVACY_POLICY_QUALIFICATION_ID = '99996';

export const QUESTION_PLACEHOLDER_SUGGESTIONS: string[] = [
  'Please select all that apply',
  'Please select one',
  'Please answer the following question',
  'Select all that apply',
  'Select one',
  'Type answer here',
];
